import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';

import HomePage from './routes/HomePage';
import OurStory from './routes/OurStory';
import WhatWeDo from './routes/WhatWeDo';
import HowWeDoIt from './routes/HowWeDoIt';
import ContactUs from './routes/ContactUs';
import ClientLogin from './routes/ClientLogin';
import ClientPasswordReset from './routes/ClientPasswordReset';
import KnowledgeCenter from './routes/KnowledgeCenter';
import KnowledgeCenterArticle from './routes/KnowledgeCenterArticle';

import './App.css';

export default () => (
  <ParallaxProvider>
    <Router>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/our-story" component={OurStory} />
        <Route path="/what-we-do" component={WhatWeDo} />
        <Route path="/how-we-do-it" component={HowWeDoIt} />
        <Route path="/contact-us" component={ContactUs} />
        <Route path="/client-login" component={ClientLogin} />
        <Route path="/password-reset" component={ClientPasswordReset} />
        <Route
          path="/knowledge-center/article/*"
          component={KnowledgeCenterArticle}
        />
        <Route path="/knowledge-center" component={KnowledgeCenter} />
        <Redirect from='/login' to='/client-login'/>
        <Redirect to="/" />
      </Switch>
    </Router>
  </ParallaxProvider>
);



// WEBPACK FOOTER //
// ./src/components/App.js